import {
  PLANNED_COLOR,
  REAL_COLOR,
  NOT_STARTED_COLOR,
} from "components/Charts/Gantt";
import dayjs from "dayjs";

export const ganttRowTypes = {
  PHASE: "phase",
  BRICK: "brick",
};

const formatGanttDate = datestring =>
  datestring ? dayjs(datestring).locale("en").format("DD MMM YYYY") : null;

// Maps a phase or a brick (same date/percentage fields) to a single Gantt row
const mapGanttRow = (item, { rowType, phaseId, hasChildren = false }) => ({
  rowKey: `${rowType}-${item.id}`,
  rowType,
  phaseId,
  hasChildren,
  expanded: false,
  name: item.name,
  plannedName: "Pianificato",
  realName: `Reale ${Math.round(item.completionPercentage).toFixed(0)}%`,
  plannedColor: PLANNED_COLOR,
  realColor: item.realStartDate ? REAL_COLOR : NOT_STARTED_COLOR,
  plannedFromDateName: "Data di inizio pianificata",
  plannedToDateName: "Data di fine pianificata",
  realFromDateName: "Data di inizio reale",
  realToDateName: `Data di fine ${item.realEndDate ? "reale" : "prevista"}`,
  plannedFromDate: formatGanttDate(item.plannedStartDate),
  plannedToDate: formatGanttDate(item.plannedEndDate),
  realFromDate: formatGanttDate(item.realStartDate || item.plannedStartDate),
  realToDate: formatGanttDate(item.realEndDate || item.expectedEndDate),
});

// Returns the phases as Gantt rows, each one carrying its own mapped bricks
export const mapGanttData = data => {
  const phases = Array.isArray(data) ? data : data?.phases || [];

  return phases.map(phase => {
    const bricks = phase.bricks || [];
    return {
      ...mapGanttRow(phase, {
        rowType: ganttRowTypes.PHASE,
        phaseId: phase.id,
        hasChildren: bricks.length > 0,
      }),
      bricks: bricks.map(brick =>
        mapGanttRow(brick, {
          rowType: ganttRowTypes.BRICK,
          phaseId: phase.id,
        })
      ),
    };
  });
};

// Flattens phases into the chart rows, inserting bricks under expanded phases
export const flattenGanttRows = (phases, expandedPhaseIds = []) =>
  (phases || []).flatMap(({ bricks, ...phase }) => {
    const expanded = expandedPhaseIds.includes(phase.phaseId);
    return [{ ...phase, expanded }, ...(expanded ? bricks : [])];
  });
